import dayjs from "@/lib/dayjs";
type Props = {
	date?: string;
	format?: string;
};

export const getLastDayOfMonth = ({ date = undefined, format = "YYYY-MM-DD" }: Props) => {
	return dayjs(date).endOf("month").format(format);
};
